const TEXT_INPUT_COLOR = {
  red: 'red',
  black: 'black',
  purple_dark: 'purple-dark',
}

const TEXT_INPUT_FORMATS = {
  currency: 'currency',
  currency2: 'currency-2',
  percentage: 'percentage',
  percentage1: 'percentage-1',
  percentage2: 'percentage-2',
  month: 'month',
  year: 'year',
}

const NUMERIC_FORMATS = {
  [TEXT_INPUT_FORMATS.currency]: true,
  [TEXT_INPUT_FORMATS.currency2]: true,
  [TEXT_INPUT_FORMATS.percentage]: true,
  [TEXT_INPUT_FORMATS.percentage1]: true,
  [TEXT_INPUT_FORMATS.percentage2]: true,
}

export {
  TEXT_INPUT_COLOR, TEXT_INPUT_FORMATS, NUMERIC_FORMATS 
}
